import { Pipe, PipeTransform } from '@angular/core';
import { differenceInHours } from 'date-fns';
import { stringOrDateToDate } from '../utilities/dateTime';

@Pipe({
  name: 'inHours',
  standalone: false,
})
export class InHoursPipe implements PipeTransform {
  public transform(value: string | Date): string {
    if (!value) {
      return '—';
    }
    const date = stringOrDateToDate(value);
    const hours = differenceInHours(date, new Date());
    if (hours < 0) {
      return '—';
    }
    return `${hours.toLocaleString()} hours`;
  }
}
